import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { ModalMedium } from '../../../../../../../../baseComponents/Modal'
import { ModalCreateEditStructureLayout } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { PdfConfigTemplateTabProps } from '../types'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { useCallback } from 'react'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender, FormSection } from '../../../../../../../../forms/FormRenderer/types'
import { PdfCssConfig } from '../../types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import FormRenderer from '../../../../../../../../forms/FormRenderer'
import TwinForm from '../../../../../../../../forms/TwinForm'
import { BeforeSubmitHandler } from '../../../../../../../../forms/TwinForm/types'
import useInputColorColors from '../../../../../../../../utils/hooks/pdf/useInputColorColors'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { ButtonRed } from '../../../../../../../../baseComponents/Button'
import { twinFetchPostText } from '../../../../../../../../utils/globals/data'
import { useParams } from 'react-router-dom'
import { addAntiUnsaveElement } from '../../../../../../../../utils/reducers/reduxDispatch'
import ModalConfigPdfDeletePage from '../ModalConfigPdfDeletePage'
import useTicketVariables from '../../../../../../../../utils/hooks/pdf/useTicketVariables'

interface PdfCssConfigExtended extends PdfCssConfig {
    name?: string
}
type ModalConfigPdfEditPageStylesProps = ModalConfigPdfEditPageStylesLogicProps & ComponentWithPermissions & {}

const ModalConfigPdfEditPageStyles: React.FC<ModalConfigPdfEditPageStylesProps> = ({ userPermissions, setOpenModal, openModal, config, ...rest }) => {
    const { t } = useTwinTranslation()
    const { prevSubmitEditModule, getMyData } = useModalConfigPdfEditPageStylesLogic({ setOpenModal, openModal, config, ...rest })
    const { colors } = useInputColorColors()
    const key = openModal?.allRowData.id
    const { fontSizes, fontWeights } = useTicketVariables()
    const allRowData = getMyData(key)

    let extraSections: FormSection<PdfCssConfigExtended>[]= []

    if (config.type === 'ticket' || config.type === 'ticketRefund' || config.type === 'voucher' || config.type === 'giftTicket' || config.type === 'cashRegister') {
        extraSections = [
            {
                cols: 3,
                className: 'mt-20',
                title: t('styles', 'Estilos'),
                elements: [
                    {
                        name: 'fontSizeTicket',
                        label: t('fontSize', 'Tamaño de letra'),
                        component: 'CustomSelect',
                        items: fontSizes
                    },
                    {
                        name: 'fontWeight',
                        label: t('fontWeight', 'Grosor letra'),
                        component: 'CustomSelect',
                        items: fontWeights
                    },
                ]
            },
        ]
    } else {
        extraSections = [
            {
                cols: 3,
                className: 'mt-20',
                title: t('styles', 'Estilos'),
                elements: [
                    {
                        name: 'fontSize',
                        label: t('fontSize', 'Tamaño de letra'),
                        id: 'fontSize',
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },
                    {
                        name: 'color',
                        label: t('letterColor', 'Color de letra'),
                        id: 'color',
                        component: 'InputColorDeleteButtonWithMargin',
                        colors: colors,
                    },
                    {
                        name: 'background',
                        id: 'background',
                        label: t('backgroundColor', 'Color de fondo'),
                        component: 'InputColorDeleteButtonWithMargin',
                        colors: colors,
                    },
                    {
                        name: 'padding',
                        id: 'padding',
                        label: t('padding', 'Margen interior'),
                        component: 'InputWithLabelMargin',
                        type: 'text'
                    },
                ]
            },
            {
                cols: 3,
                className: 'mt-20',
                title: t('background', 'Fondo'),
                elements: [
                    {
                        name: 'backgroundImage',
                        label: t('backgroundImage', 'Imagen de fondo'),
                        component: 'ImageInput',
                        defaultValue: allRowData?.backgroundImageParsed
                    }
                ]
            }
        ]
        if (config.type === 'productCertificate') {
            extraSections.push({
                cols: 3,
                className: 'mt-20',
                title: t('sizes', 'Tamaños'),
                elements: [
                    {
                        name: 'width',
                        label: t('width', 'Ancho'),
                        id: 'width',
                        component: 'InputNumberWithLabelMarginStateFull',
                        type: 'text'
                    },
                    {
                        name: 'height',
                        label: t('height', 'Altura'),
                        id: 'height',
                        component: 'InputNumberWithLabelMarginStateFull',
                        type: 'text'
                    },
                ]
            })
        }
    }

    const sections: FormRender<PdfCssConfigExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('pageName', 'Nombre de la página'),
                    id: 'name',
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
            ]
        },
        ...extraSections
    ]

    const deleteButton = <ButtonRed onClick={(e) => { setOpenModal({ type: 'delete', allRowData: { id: openModal?.allRowData.id } }); e.preventDefault() }}><TwinTrans transKey='deletePage'>Borrar página</TwinTrans></ButtonRed>
    const parsedFields = valueOrDefaultValue(sections, userPermissions, allRowData)
    return (
        <ModalMedium setOpened={() => setOpenModal(null)} opened={true} className='flex flex-col'>
            <TwinForm beforeSubmitHandler={prevSubmitEditModule} className='flex flex-auto flex-col notFlexAutoFormRender' imagepath={['pdfTemplate', String(config?.id)]}>
                <ModalCreateEditStructureLayout translations={{ button: t('save', 'Guardar'), title: t('configPage', 'Configurar página') }} extraButtons={[deleteButton]} loading={false} haveButtonPermissions={permissionCheck(userPermissions, 'update')} className='modal_negative_margin flex flex-col'>
                    <div className='overflow-auto flex flex-auto flex-col'>
                        <FormRenderer sections={parsedFields} />
                    </div>
                </ModalCreateEditStructureLayout>
            </TwinForm>
            {openModal?.type === 'delete' ? <ModalConfigPdfDeletePage myKey={key} setOpenModal={setOpenModal} openModal={openModal} config={config} setConfig={rest.setConfig} /> : null}
        </ModalMedium>
    )
}

interface ModalConfigPdfEditPageStylesLogicProps extends PdfConfigTemplateTabProps { }

const useModalConfigPdfEditPageStylesLogic = ({ openModal, setOpenModal, setConfig, config }: ModalConfigPdfEditPageStylesLogicProps) => {
    const { id } = useParams()
    const saveInfo = useCallback(async (vals: any) => {
        await addAntiUnsaveElement(['pdf_template_changes', '{}'])
        const allRowData = openModal?.allRowData
        if (allRowData) {
            let myImage = vals.backgroundImage
            if (myImage) {
                const myImageSplited = myImage.split('/')
                myImage = '/' + myImageSplited.splice(myImageSplited.length - 1, 1)
                const myUrlParsed = await twinFetchPostText('/api/app/fileSystem/getLinkOfFile', { type: 'pdfTemplate', subFolder: '/' + id, filepath: myImage })
                vals['backgroundImageParsed'] = myUrlParsed
            } else if (myImage === '') {
                vals['backgroundImageParsed'] = ''
                vals['backgroundImage'] = ''
            }
            setConfig((old) => {
                if (!old) {
                    return null
                }
                const copy = JSON.parse(JSON.stringify(old))
                const myKey = allRowData.id.split('page')[1]
                copy.pages[myKey].name = vals.name
                delete vals.name
                copy.pages[myKey].cssConfig = { ...copy.pages[myKey].cssConfig, ...vals, name: undefined }
                return { ...copy }
            })
            setOpenModal(null)
        }
    }, [setConfig, setOpenModal, openModal, id])

    const prevSubmitEditModule: BeforeSubmitHandler = useCallback((vals) => {
        saveInfo(vals)
        return false
    }, [saveInfo])

    const getMyData = useCallback((key: string) => {
        let allRowData: any = {}
        if (key) {
            let myconfig: any = { ...config }
            let myKey = key
            myKey = key.split('page')[1]
            if (myconfig.pages[myKey]) {
                allRowData = myconfig.pages[myKey]?.cssConfig
                allRowData['name'] = myconfig.pages[myKey].name
            }
        }
        return allRowData
    }, [config])

    return { prevSubmitEditModule, getMyData }
}

export default ModalConfigPdfEditPageStyles